import React, { Fragment } from 'react';
import LegendItem from './LegendItem';
import styles from '../Sunburst.module.css';

interface LegendItemData {
	name: string;
	color?: string;
	value?: number;
	data?: any;
	depth?: number;
	level?: number;
	node?: any;
	parent?: any;
}

const Legend: React.FC<{
	legendData: LegendItemData[],
	totalLevel1Sessions: number,
	selectedJourneyData: LegendItemData | null,
	handleArcClick: (item: any) => void,
	isTunnel?: boolean,
	tunnelData?: LegendItemData[]
}> = ({
	legendData,
	totalLevel1Sessions,
	handleArcClick,
}) => {


	const getDepth = (item: LegendItemData): number => {
		return typeof item.depth === 'number' ? item.depth :
			typeof item.level === 'number' ? item.level : 0;
	};

	const normalDisplayList = legendData ? 
		legendData.filter(item => getDepth(item) !== 0) : [];

	const displayList =  normalDisplayList;



	return (
		<>
			<div className={styles.legendList}>
				{displayList.map((item, idx) => (
					<Fragment key={item.name + '-' + idx}>
						<LegendItem
							key={`${item.name}-${idx}-item`}
							onClick={() => handleArcClick(item.node ? item.node : item)}
							isClickable={!(item.name === 'Site exit' || item.name === 'LostSession')}
							item={item}
							totalLevel1Sessions={totalLevel1Sessions}
						/>
					</Fragment>
				))}
			</div>
		</>
	);
};

export default Legend;